import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './style1.css';

interface CertificateItem {
    id: number;
    name: string;
    url: string;
}

interface CertificatesProps {
    username?: string;
    onLogout?: () => void;
}

const navLinks = [
    { name: 'HOME', href: '/' },
    { name: 'PROGRAMS', href: '/programs' },
    { name: 'VIDEOS', href: '/videos' },
    { name: 'IMAGES', href: '/images' },
    { name: 'DEMOS', href: '/demos' },
    { name: 'CERTIFICATES', href: '/certificates' },
    { name: 'ABOUT', href: '/about' },
];

const Certificates: React.FC<CertificatesProps> = ({ username, onLogout }) => {
    const [certificates, setCertificates] = useState<CertificateItem[]>([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [menuOpen, setMenuOpen] = useState(false);
    const [showFullImage, setShowFullImage] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem('token');
        fetch('/allcertificates', {
            headers: token ? { 'Authorization': `Bearer ${token}` } : {}
        })
            .then(res => res.json())
            .then(data => setCertificates(data))
            .catch(() => setCertificates([]));
    }, []);

    const showPrev = () => {
        setCurrentIndex((prev) => (prev === 0 ? certificates.length - 1 : prev - 1));
    };

    const showNext = () => {
        setCurrentIndex((prev) => (prev === certificates.length - 1 ? 0 : prev + 1));
    };

    const currentCertificate = certificates[currentIndex];

    return (
        <div className="modern-layout">
            <header className="modern-header">
                <div className="header-container">
                    <nav className={`modern-nav ${menuOpen ? 'open' : ''}`}>
                        {navLinks.map(link =>
                            link.href.startsWith('/')
                                ? <Link
                                    key={link.name}
                                    to={link.href}
                                    className="modern-nav-link"
                                    style={{ textDecoration: 'none' }}
                                  >
                                    {link.name}
                                  </Link>
                                : <a
                                    key={link.name}
                                    href={link.href}
                                    className="modern-nav-link"
                                  >
                                    {link.name}
                                  </a>
                        )}
                        <button className="logout-btn" onClick={onLogout}>LOG OUT</button>
                    </nav>
                    <button
                        className="menu-toggle"
                        onClick={() => setMenuOpen(!menuOpen)}
                        aria-label="Toggle menu"
                    >
                        <span className="menu-icon">&#9776;</span>
                    </button>
                </div>
            </header>
            <main className="modern-content">
                <h2 style={{ textAlign: 'center' }}>Certificates</h2>
                {certificates.length > 0 && (
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '2rem',
                        marginTop: '2rem',
                        width: '100%',
                    }}>
                        <button
                            aria-label="Previous certificate"
                            onClick={showPrev}
                            style={{
                                fontSize: '2rem',
                                background: 'none',
                                border: 'none',
                                color: '#2575fc',
                                cursor: 'pointer',
                                padding: '0.5rem 1rem',
                                borderRadius: '50%',
                                transition: 'background 0.2s'
                            }}
                        >
                            &#8592;
                        </button>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%',
                            maxWidth: '840px',
                            minHeight: '441px',
                        }}>
                            <img
                                src={currentCertificate.url}
                                alt={currentCertificate.name}
                                style={{
                                    width: '100%',
                                    maxWidth: '630px',
                                    borderRadius: '16px',
                                    boxShadow: '0 2px 16px #6a11cb22',
                                    background: '#fff',
                                    cursor: 'pointer'
                                }}
                                onClick={() => setShowFullImage(true)}
                            />
                            <div style={{
                                marginTop: '1rem',
                                color: '#222',
                                fontSize: '1rem',
                                textAlign: 'center'
                            }}>
                                Click image to view it
                            </div>
                        </div>
                        <button
                            aria-label="Next certificate"
                            onClick={showNext}
                            style={{
                                fontSize: '2rem',
                                background: 'none',
                                border: 'none',
                                color: '#2575fc',
                                cursor: 'pointer',
                                padding: '0.5rem 1rem',
                                borderRadius: '50%',
                                transition: 'background 0.2s'
                            }}
                        >
                            &#8594;
                        </button>
                    </div>
                )}
                {certificates.length === 0 && (
                    <div style={{ textAlign: 'center', marginTop: '2rem', color: '#888' }}>
                        No certificates found.
                    </div>
                )}
                {showFullImage && (
                    <div
                        style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100vw',
                            height: '100vh',
                            background: 'rgba(0,0,0,1)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 1000
                        }}
                        onClick={() => setShowFullImage(false)}
                    >
                        <img
                            src={currentCertificate.url}
                            alt={currentCertificate.name}
                            style={{
                                maxWidth: '90vw',
                                maxHeight: '90vh',
                                borderRadius: '24px',
                                boxShadow: '0 2px 32px #6a11cb88',
                                background: '#fff',
                                display: 'block'
                            }}
                        />
                    </div>
                )}
            </main>
            <footer className="modern-footer">
                &copy; {new Date().getFullYear()} Timo
            </footer>
        </div>
    );
};

export default Certificates;